var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.item.visible
    ? _c(
        "li",
        {
          staticClass: "navigation-item",
          class: {
            "navigation-item-active": _vm.active,
          },
        },
        [
          _vm.hasChildren()
            ? [
                _c(
                  "div",
                  {
                    staticClass: "navigation-title",
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.item.url,
                          title: _vm.navigateToText(_vm.item.title),
                          "aria-label": _vm.navigateToText(_vm.item.title),
                          tabindex: "0",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "navigation-icon",
                          },
                          [
                            _vm.isCourse
                              ? _c("studip-icon", {
                                  attrs: {
                                    shape: "seminar",
                                    role: "info_alt",
                                    size: 24,
                                    alt: "",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.icon
                              ? _c("img", {
                                  class: {
                                    avatar: _vm.item.avatar,
                                  },
                                  attrs: {
                                    src: _vm.iconUrl,
                                    width: "24",
                                    alt: "",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "navigation-text",
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.item.title) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "styleless navigation-in",
                    attrs: {
                      title: _vm.openNavigationText(_vm.item.title),
                      "aria-label": _vm.openNavigationText(_vm.item.title),
                    },
                    on: {
                      click: function click($event) {
                        return _vm.moveTo(_vm.item.path)
                      },
                      keydown: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          $event.preventDefault()
                          return _vm.moveTo(_vm.item.path)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar",
                            ])
                          )
                            return null
                          $event.preventDefault()
                          return _vm.moveTo(_vm.item.path)
                        },
                      ],
                    },
                  },
                  [
                    _c("studip-icon", {
                      attrs: {
                        shape: "arr_1right",
                        role: "info_alt",
                        size: 20,
                        alt: "",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _c(
                "div",
                {
                  staticClass: "navigation-title",
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.item.url,
                        tabindex: "0",
                        title: _vm.navigateToText(_vm.item.title),
                        "aria-label": _vm.navigateToText(_vm.item.title),
                      },
                    },
                    [
                      _vm.isCourse
                        ? _c("studip-icon", {
                            attrs: {
                              shape: "seminar",
                              role: "info_alt",
                              size: 24,
                              alt: "",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item.icon
                        ? _c("img", {
                            class: {
                              avatar: _vm.item.avatar,
                            },
                            attrs: {
                              src: _vm.iconUrl,
                              width: "24",
                              alt: "",
                            },
                          })
                        : _vm._e(),
                      _vm._v(
                        "\n            " + _vm._s(_vm.item.title) + "\n        "
                      ),
                    ],
                    1
                  ),
                ]
              ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }